import React from "react";
import { pddRoot } from "../../utils/defaultValues";
import PddModuleHome from "./PddModuleHome";
import IntlMessages from "../../utils/IntlMessages";
import ProjectListRouteConfig from "./feature-bundle/project-list/ProjectListRouteConfig";
import ProjectDashboardRouteConfig from "./feature-bundle/project-dashboard/ProjectDashboardRouteConfig";
import AssetOverviewRouteConfig from "./feature-bundle/asset-management/AssetOverviewRouteConfig";
import BuildingProfileRouteConfig from "./feature-bundle/building-profile/BuildingProfileRouteConfig";
import KeyFindingsHomeRouteConfig from "./feature-bundle/key-findings/KeyFindingsHomeRouteConfig";
import PhotoDocumentationRouteConfig from "./feature-bundle/photodocumentation/PhotoDocumentationRouteConfig";
import customReportRouteConfig from "./feature-bundle/custom-report/customReportRouteConfig";
import FullReportRouteConfig from "./feature-bundle/full-report/FullReportRouteConfig";
import PddProjectScopeWrapper from "./PddProjectScopeWrapper";
import ArchitectureIcon from "@mui/icons-material/Architecture";
import ListIcon from "@mui/icons-material/List";
import ApartmentIcon from "@mui/icons-material/Apartment";
import GridViewIcon from '@mui/icons-material/GridView';
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import LinkedCameraIcon from "@mui/icons-material/LinkedCamera";
import RoomPreferencesIcon from "@mui/icons-material/RoomPreferences";
import ConstructionIcon from "@mui/icons-material/Construction";
import PostAddIcon from "@mui/icons-material/PostAdd";

const PddModuleRouteConfig = {
  routes: [
    {
      path: `${pddRoot}/`,
      exact: true,
      name: <IntlMessages id={`menu.pdd-management`} />,
      element: <PddModuleHome />,
      icon: (
        <ArchitectureIcon style={{ width: 22, height: 22, color: "#637381" }} />
      ),
      isParent: true,
      showBreadCrumbs: true,
      auth: [],
      children: [
        ...ProjectListRouteConfig.routes.map((u) => ({
          ...u,
          id: "pdd-project-list",
          parentPath: `${pddRoot}/`,
          showBreadCrumbs: true,
          icon: (
            <ListIcon
              style={{ marginLeft: 5, width: 22, height: 22, color: "#244a9a" }}
            />
          ),
        })),
        ...ProjectDashboardRouteConfig.routes.map((u) => ({
          ...u,
          id: "pdd-project-dashboard",
          showBreadCrumbs: false,
          parentPath: `${pddRoot}/`,
          element: <PddProjectScopeWrapper>{u.element}</PddProjectScopeWrapper>,
          icon: (
            <GridViewIcon
              style={{ marginLeft: 5, width: 22, height: 22, color: "#244a9a" }}
            />
          ),
        })),
        ...AssetOverviewRouteConfig.routes.map((u) => ({
          ...u,
          id: "pdd-assets-overview",
          parentPath: `${pddRoot}/`,
          showBreadCrumbs: true,
          element: <PddProjectScopeWrapper>{u.element}</PddProjectScopeWrapper>,
          icon: (
            <ApartmentIcon
              style={{ marginLeft: 5, width: 22, height: 22, color: "#244a9a" }}
            />
          ),
        })),
        ...BuildingProfileRouteConfig.routes.map((u) => ({
          ...u,
          id: "pdd-building-profile",
          showBreadCrumbs: true,
          parentPath: `${pddRoot}/`,
          element: <PddProjectScopeWrapper>{u.element}</PddProjectScopeWrapper>,
          icon: (
            <RoomPreferencesIcon
              style={{ marginLeft: 5, width: 22, height: 22, color: "#244a9a" }}
            />
          ),
        })),
        ...KeyFindingsHomeRouteConfig.routes.map((u) => ({
          ...u,
          id: "pdd-project-defects",
          showBreadCrumbs: true,
          parentPath: `${pddRoot}/`,
          element: <PddProjectScopeWrapper>{u.element}</PddProjectScopeWrapper>,
          icon: (
            <ConstructionIcon
              style={{ marginLeft: 5, width: 22, height: 22, color: "#244a9a" }}
            />
          ),
        })),
        ...PhotoDocumentationRouteConfig.routes.map((u) => ({
          ...u,
          id: "pdd-photo-documentation",
          showBreadCrumbs: true,
          parentPath: `${pddRoot}/`,
          element: <PddProjectScopeWrapper>{u.element}</PddProjectScopeWrapper>,
          icon: (
            <LinkedCameraIcon
              style={{ marginLeft: 5, width: 22, height: 22, color: "#244a9a" }}
            />
          ),
        })),
        ...customReportRouteConfig.routes.map((u) => ({
          ...u,
          id: "pdd-custom-report",
          showBreadCrumbs: true,
          parentPath: `${pddRoot}/`,
          element: <PddProjectScopeWrapper>{u.element}</PddProjectScopeWrapper>,
          icon: (
            <PostAddIcon
              style={{ marginLeft: 5, width: 22, height: 22, color: "#244a9a" }}
            />
          ),
        })),
        ...FullReportRouteConfig.routes.map((u) => ({
          ...u,
          id: "pdd-full-report",
          showBreadCrumbs: true,
          parentPath: `${pddRoot}/`,
          element: <PddProjectScopeWrapper>{u.element}</PddProjectScopeWrapper>,
          icon: (
            <AutoStoriesIcon
              style={{ marginLeft: 5, width: 22, height: 22, color: "#244a9a" }}
            />
          ),
        })),
      ],
    },
  ],
};

export default PddModuleRouteConfig;
